// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4b094160]:export {\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #304156;\n  menuHover: #263445;\n  subMenuBg: #1f2d3d;\n  subMenuHover: #001528;\n  sideBarWidth: 210px;\n}\n.reject_reason_form[data-v-4b094160]  .ant-form-item {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
